import {
  isVendorMembershipCustomerSource,
  formatVendorMembershipSourceLabel,
} from '../../components/service-history/vendor-membership-customer-source.util';

/**
 * The plate-sync warning for a vendor-imported customer (CWS-1384).
 *
 * A customer imported from DRB keeps their plate in DRB, and the import writes that
 * value back over ours. Editing the plate here still works and still takes effect at
 * the lane immediately, so this never blocks the save — it tells the operator the
 * change is theirs to make in the vendor system too, or it will come back.
 *
 * Worded from the vendor's own name so a shop on EverWash is not told about DRB.
 */
export function vendorPlateSyncWarning(source: string | null | undefined): string | null {
  if (!isVendorMembershipCustomerSource(source)) {
    return null;
  }
  const vendor = formatVendorMembershipSourceLabel(source);
  return `This customer was imported from ${vendor}. ${vendor} holds the license plate of record, so update it there too — otherwise the next sync will restore the old plate.`;
}

/** Whether a plate edit for this customer should carry the vendor sync warning. */
export function hasVendorPlateSyncWarning(source: string | null | undefined): boolean {
  return vendorPlateSyncWarning(source) !== null;
}
